module.exports = __webpack_public_path__ + "img/calendar-rangeF38235.dc483f44.svg";